import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import * as styles from './OutlineButton.module.scss'
import { Icon } from '@iconify/react'

const OutlineButton = ({ buttonData, type, location = 'internal' }) => {
  // type: white, colored
  //ButtonData:{
  //     text: '',
  //     url: '',
  //     icon:''
  //     location: internal, external,
  //     state:{} optional
  //   }
  //
  return (
    <Fragment>
      {buttonData.location === 'external' || location === 'external' ? (
        <a
          href={buttonData.url}
          rel={buttonData.openSeperate && 'noreferrer'}
          target={buttonData.openSeperate && '_blank'}
          className={`btn ${styles.outline_btn} ${styles[`${type}`]}`}
        >
          {buttonData.icon ? (
            <Icon
              className={styles.btn_icon}
              icon={buttonData.icon}
              inline={true}
              width="20"
              height="20"
              vAlign="center"
            />
          ) : (
            ''
          )}
          {buttonData.text}
          <Icon
            icon="eva:arrow-forward-fill"
            className={styles.btn_arrow}
            inline={true}
            width="18"
            height="18"
            vAlign="center"
          />
        </a>
      ) : (
        <Link
          to={buttonData.url}
          state={buttonData?.state ? buttonData.state : {}}
          className={`btn ${styles.outline_btn} ${styles[`${type}`]}`}
        >
          {buttonData.icon ? (
            <Icon
              className={styles.btn_icon}
              icon={buttonData.icon}
              inline={true}
              width="20"
              height="20"
              vAlign="center"
            />
          ) : (
            ''
          )}
          {buttonData.text}
          <Icon
            icon="eva:arrow-forward-fill"
            className={styles.btn_arrow}
            inline={true}
            width="18"
            height="18"
            vAlign="center"
          />
        </Link>
      )}
    </Fragment>
  )
}

export default OutlineButton
